import type { UserBody } from '~/types';
import { BodiesModel } from '~/models';
import { useGenericCrudMethods } from '~/composables';

export function useBodies() {
    const apiBasePath = `/v1/bodies`;
    const genericCrudMethods = useGenericCrudMethods<UserBody>(apiBasePath, BodiesModel);

    return {
        ...genericCrudMethods
    };
}
